const CONTEXT_KEYS = {
  PAGE_TITLE: 'pageTitle',
  POSTS_LIST: 'postsList',
  CUSTOM_CONTENT_CLASS: 'customContentClass',
  CUSTOM_HEADER_CLASS: 'customHeaderClass',
}

export { CONTEXT_KEYS }
